import { orchestrator } from 'satcheljs';
import { setCalendarColor } from '../actions/calendarActions';
import { setCalendarColor as setCalendarColorAction } from 'owa-calendar-update';
import { setCalendarHexColor } from 'owa-calendar-surface-calendars-store';

orchestrator(setCalendarColor, actionMessage => {
    const { colorScheme, hexColorString, calendar } = actionMessage;

    if (hexColorString) {
        setCalendarHexColor(calendar, hexColorString);
    } else if (colorScheme) {
        setCalendarHexColor(calendar, colorScheme.calPrimary);
    } else {
        setCalendarColorAction(calendar, -1);
    }
});
